import clsx from "clsx";
import Link from "next/link";
import { FC } from "react";

interface InspectionAreasProps {
  className?: string;
  ctaLabel: string;
  ctaHref: string;
}

export const InspectionAreas: FC<InspectionAreasProps> = ({
  className,
  ctaLabel,
  ctaHref,
}) => {
  return (
    <div className={clsx(className)}>
      <Link
        href={ctaHref}
        className="mb-4 inline-block rounded-lg bg-sky-700 px-6 py-3 font-semibold text-white transition-colors duration-200 hover:bg-sky-800"
      >
        {ctaLabel}
      </Link>
    </div>
  );
};
